<template>
	<div id="app">
		<common-header />
		<router-view />
		<common-footer />
	</div>
</template>

<script>
	import CommonHeader from './view/header/index.vue'
	import CommonFooter from './view/footer/index.vue'
	export default {
		components: {
			CommonHeader,
			CommonFooter
		}
	}
</script>

<style lang="scss">
	.part {
		width: 1400px;
		overflow: hidden;
		margin-left: auto;
		margin-right: auto;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue